import { HttpClient, HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RequestErrorThrower } from 'app/trello/services/request-error-thrower';
import { TokenService } from 'app/trello/services/token.service';
import { TrelloService } from 'app/trello/services/trello.service';
import { Templating } from 'app/trello/templating.imports';
import DOMPurify from 'dompurify';
import { environment } from 'environments/environment';
import { marked } from 'marked';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { IftaLabel } from 'primeng/iftalabel';
import { ProgressSpinner } from 'primeng/progressspinner';
import { Textarea } from 'primeng/textarea';
import { catchError, map, switchMap, take, tap } from 'rxjs';

@Component({
  selector: 'app-card-chat-component',
  styleUrls: ['./card-chat.component.css'],
  templateUrl: './card-chat.component.html',
  imports: [
    Templating,
    FormsModule,
    IftaLabel,
    Textarea,
    Button,
    Card,
    ProgressSpinner
  ]
})
export class CardChatComponent {

  protected chat: string = '';
  protected reply: string = '';

  protected sending = false;

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly http: HttpClient,
    private readonly requestErrorThrower: RequestErrorThrower,
    private readonly tokenService: TokenService,
    private readonly trelloService: TrelloService, // required
  ) {
  }

  reset() {

    this.chat = '';
    this.reply = '';

    this.sending = false;

    this.changeDetector.detectChanges();
  }

  sendChat(
    chat: string | undefined = undefined,
  ) {

    if (this.sending) {
      return;
    }

    this.sending = true;

    if (chat) {
      this.chat = chat;
    }

    this.changeDetector.detectChanges();

    const body = new HttpParams().set('chat', this.chat);

    const url = `${environment.apiRoot}${environment.endpoints.cardChat}`;

    this.tokenService.userToken
      .pipe(
        take(1),
        switchMap((userToken) =>

          this.http.post(
            url,
            body,
            {headers: {Authorization: `Bearer ${userToken}`}},
          )
        ),
        map((httpResponse: any) => marked(httpResponse.response)),
        tap((markedResponse: any) => this.reply = DOMPurify.sanitize(markedResponse)),
        tap(() => this.changeDetector.detectChanges()),
        catchError((error: any) => {

          console.error('An error occurred asking devin:', error);

          return this.requestErrorThrower.throwError(error);
        }),
      )
      .subscribe();
  }

}
